import React from "react";
import LandingPageHeader from "components/Headers/LandingPageHeader";
import TextGrid from "components/TextGrid";
import Event from "components/Event";
import Exibex from "components/Exibex";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import PastSpeakers from "components/PastSpeakers";
import Spotlight from "components/Spotlight";
import Sponsor from "components/Sponsor";
import Awards from "components/Awards";
import Register from "components/Register";

import { live, speakers, sponsors, sponsorsPage } from "./content";

import ScrollUpButton from "react-scroll-up-button";
import Quotes from "components/Quotes";
import MainStats from "components/MainStats";
import SponsorOld from "components/SponsorOld";
import Speakers from "components/Speaker";
import ParticleBackground from "components/Particles";
import Live from "components/Live";

function Home() {
  return (
    <div id="outer-container">
      <div
        style={{
          background: "#000",
          backgroundImage: "url(" + require("assets/images/services_bg.jpg") + ")",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
        }}
      >
        <Navbar page="home" home />
        <ScrollUpButton />
        <LandingPageHeader home />
        <Quotes />
        <TextGrid />

        <MainStats />
        <Spotlight />
        <section id="speakers" />
        <Speakers />
        {/* <PastSpeakers speakers={speakers} showTitle/> */}
      </div>
      <Event />
      <div
        style={{
          background: "#000",
          backgroundImage: "url(" + require("assets/images/services_bg.jpg") + ")",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
        }}
      >
        <Awards />
        <section id="partners" />
        <Sponsor sponsors={sponsorsPage} />
        <SponsorOld sponsors={sponsors} />
        {/* <Price /> */}
        <section id="register" />
        <Register title={"Register"} />
        <Live live={live} />
        <Exibex />

        <Footer />
        <ParticleBackground />
      </div>
    </div>
  );
}

export default Home;
